// extracted by mini-css-extract-plugin
module.exports = {"SwitchMapViewButton":"SwitchMapViewButton","MuiButtonBase-root":"MuiButtonBase-root","isActive":"isActive"};